<template>
    <div>
        <HeadNav selectedLanguage="en" page="download" />
        <div class="features-section">
<h1>Download WhatsApp Mods APK – 2026 Anti-Ban Updated Versions</h1>
            <!-- <div class="discover-features">
                Discover what makes <a href="https://gbmodshub.com/" class="jump-url">GBWhatsApp</a> the ultimate WhatsApp mod. With enhanced privacy, full customization,
                and advanced messaging tools, GB WhatsApp gives you more control than the official app ever could.
            </div> -->
            <div class="mod-features">
                <div v-for="(item, index) in featuresList" :key="index" class="modfeature-item" @click="goJump(item.link)">
                    <div>
                        <img :src="item.img" style="width: 70px; height: 70px;" alt="">
                    </div>
                    <div>
                        <strong>{{ item.title }}</strong>
                    </div>
                </div>
            </div>
            <h2 class="intro-title"> GB WhatsApp Alternatives</h2>
            <div class="quick-overview">
                Looking for apps similar to GB WhatsApp? Here are the most popular alternatives that offer similar — and in some cases unique — features for enhanced messaging and privacy control: <br>
                <br> 
                <strong>📱 FM WhatsApp</strong> <br>
                FM WhatsApp is known for its anti-ban protection, advanced privacy settings, and visual customization. It supports app locking, status hiding, and even allows you to send messages to unsaved numbers. A solid choice for those who want stability and flexibility. <br><br>
                <strong>🎨 YO WhatsApp (YoWA)</strong> <br>
                YO WhatsApp combines the stock WhatsApp experience with deep personalization features. It offers a clean, user-friendly interface with the ability to hide chats, apply themes, and change icons. It's lightweight and great for users who love visual tweaks. <br><br>
                
                <strong>➕ WhatsApp Plus</strong> <br>
                One of the oldest and most trusted WhatsApp mods, WhatsApp Plus offers extended file-sharing limits, a large library of themes, and improved security tools. Ideal for users who want a balanced mix of aesthetics and performance.<br><br>
                
            </div>

            <div class="footer-choose">
                <strong>💡 Which One Should You Choose?</strong> <br>
                All these mods share core features like enhanced privacy, theme support, and file sharing. The best choice depends on your priorities — GB WhatsApp is great for all-round performance, FM WhatsApp is more stable and secure, YO WhatsApp offers sleek design, and WhatsApp Plus delivers a classic modding experience. 
            </div>
        </div>
    </div>
</template>
<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
    name: 'Features',
    components: {
        HeadNav},
    data() {
        return {
            apk: null,
            featuresList: [
                {
                    title: "GB WhatsApp",
                    img: require('@/assets/logo.png'),
                    link: "https://gbmodshub.com/",
                },
                {
                    title: "FM WhatsApp",
                    img: require('@/assets/fm-logo.webp'),
                    link: "https://gbmodshub.com/fm-whatsapp-download/",
                },
                {
                    title: "YO WhatsApp",
                    img: require('@/assets/yo-logo.webp'),
                    link: "https://gbmodshub.com/yo-whatsapp-download/",
                },
                {
                    title: "WhatsApp Plus",
                    img: require('@/assets/plus-logo.webp'),
                    link: "https://gbmodshub.com/whatsapp-plus-download/",
                },
               
            ],
        }
    },
    mounted() {
        this.getOfficalApk();
    },
    methods: {
        getOfficalApk(type = 1, domain = null, appname = null) {
            this.$server
                .getOfficalApk({
                    domain: domain || 'gbwhatsapp.chat',
                    appName: appname || 'GB_gbwhatsapp.chat',
                })
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        if (type == 1) {
                            this.apk = res.data.apk;
                        }

                    } else {
                        this.apk = process.env.VUE_APP_GBLINK;
                    }
                });
        },
        goJump(url) {
            if (url) {
                window.location.href = url;
            }
        },
        gotodownload() {
            console.log(this.apk);
            // this.showapk = true
            if (this.apk) {
                this.$global.download(this.apk);
            }

        },
    }
}
</script>